<template>
  <v-row v-if="nameField === 'citicenship'">
    <v-col cols="12" v-for="k in value.length" :key="k" class="py-0">
      <div :class="arrayFieldRowClass(k)">
        <v-combobox
          :items="citicenships"
          v-model="value[k - 1]"
          :label="fieldLabel"
          :placeholder="fieldPlaceholder"
          :disabled="disabledForm"
          :ref="`${nameField}${k - 1}`"
          :readonly="readOnly"
          :rules="effectiveFieldRules"
          :counter="counterFor(value[k - 1], 80)"
          @change="$emit('change')"
          outlined
          hide-details="auto"
          class="array-field-control"
        />
        <v-btn
          v-if="canRemoveItem && !(disabledForm || readOnly)"
          icon
          color="error"
          :aria-label="$t('button.delete')"
          :title="$t('button.delete')"
          class="array-field-delete"
          @click="removeItem(k - 1)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-col>
    <v-col cols="12" class="py-0">
      <v-btn
        v-if="canAddItem(6)"
        text
        small
        color="primary"
        class="array-field-add"
        @click="addItem()"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.add") }}
      </v-btn>
    </v-col>
  </v-row>
  <v-row v-else-if="nameField === 'keywords'">
    <v-col cols="12" v-for="k in value.length" :key="k" class="py-0">
      <div :class="arrayFieldRowClass(k)">
        <v-combobox
          :items="keywords"
          v-model="value[k - 1]"
          :label="fieldLabel"
          :placeholder="fieldPlaceholder"
          :disabled="disabledForm"
          :ref="`${nameField}${k - 1}`"
          :readonly="readOnly"
          :rules="rules.char_max_80"
          :counter="counterFor(value[k - 1], 80)"
          @change="$emit('change')"
          outlined
          hide-details="auto"
          class="array-field-control"
        />
        <v-btn
          v-if="canRemoveItem && !(disabledForm || readOnly)"
          icon
          color="error"
          :aria-label="$t('button.delete')"
          :title="$t('button.delete')"
          class="array-field-delete"
          @click="removeItem(k - 1)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-col>
    <v-col cols="12" class="py-0">
      <v-btn
        v-if="canAddItem(6)"
        text
        small
        color="primary"
        class="array-field-add"
        @click="addItem()"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.add") }}
      </v-btn>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col cols="12" v-for="k in value.length" :key="k" class="py-0">
      <div :class="arrayFieldRowClass(k)">
        <v-text-field
          v-model="value[k - 1]"
          :label="fieldLabel"
          :placeholder="fieldPlaceholder"
          :disabled="disabledForm"
          :ref="`${nameField}${k - 1}`"
          :readonly="readOnly"
          :rules="nameField === 'email' ? emailRules : []"
          :counter="nameField === 'email' ? counterFor(value[k - 1], 60) : false"
          @blur="reviewEmail(k - 1)"
          outlined
          hide-details="auto"
          class="array-field-control"
        />
        <v-btn
          v-if="canRemoveItem && !(disabledForm || readOnly)"
          icon
          color="error"
          :aria-label="$t('button.delete')"
          :title="$t('button.delete')"
          class="array-field-delete"
          @click="removeItem(k - 1)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
      <v-alert v-if="emailSuggestion(k - 1)" text dense type="warning" class="email-placeholder-warning mt-2 mb-3" role="status">
        <div>{{ $t('emailPlaceholder.warning') }}</div>
        <div class="email-placeholder-proposal">{{ emailSuggestion(k - 1) }}</div>
        <v-btn text small color="primary" :disabled="disabledForm || readOnly" @click="useEmailSuggestion(k - 1)">{{ $t('emailPlaceholder.use') }}</v-btn>
      </v-alert>
    </v-col>
    <v-col cols="12" class="py-0">
      <v-btn
        v-if="canAddItem(4)"
        text
        small
        color="primary"
        class="array-field-add"
        @click="addItem()"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.add") }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
import { looksLikePlaceholderEmail, placeholderEmail } from "../../utils/emailPlaceholder";
export default {
  mixins: [validationRules],
  props: [
    "value",
    "disabledForm",
    "nameField",
    "label",
    "placeholder",
    "readOnly",
    "fieldRules",
    "suggestExampleEmails",
    "personId"
  ],
  name: "ArrayFieldForm",
  data() {
    return {
      reviewedEmails: {},
      emailRules: [
        v => !!v || this.$t("forms.field.validation.required"),
        v =>
          (!!v && /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(v)) ||
          this.$t("forms.field.validation.email.valid"),
        v =>
          (!!v && v.length <= 60) ||
          this.$t("forms.field.validation.email.long"),
        v =>
          (!!v && v.length >= 5) ||
          this.$t("forms.field.validation.email.short")
      ],
      keywords: [],
      citicenships: [],
    };
  },

  created() {
    if (this.nameField === "keywords") {
      let path = this.$store.state.endpoint + "/utils/keywords";
      axios
        .get(path)
        .then(response => {
          this.keywords = response.data.sort((a, b) => { return a > b; } );
        })
        .catch(error => {
          console.log(error);
        });
    }
    else if (this.nameField === "citicenship") {
      this.citicenships = [
        "España",
        "Argelia",
        "Argentina",
        "Austria",
        "Bélgica",
        "Bolivia",
        "Brasil",
        "Chile",
        "China",
        "Colombia",
        "Croacia",
        "Chipre",
        "República Checa",
        "Dinamarca",
        "Ecuador",
        "Egipto",
        "Estonia",
        "Finlandia",
        "Francia",
        "Alemania",
        "Grecia",
        "Hungría",
        "India",
        "Irán",
        "Irak",
        "Irlanda",
        "Israel",
        "Italia",
        "Japón",
        "Jordania",
        "Kazajistán",
        "Kuwait",
        "Letonia",
        "Líbano",
        "Libia",
        "Lituania",
        "Luxemburgo",
        "Malta",
        "México",
        "Marruecos",
        "Países Bajos",
        "Noruega",
        "Omán",
        "Pakistán",
        "Palestina",
        "Perú",
        "Polonia",
        "Portugal",
        "Qatar",
        "Rumanía",
        "Rusia",
        "Arabia Saudita",
        "Eslovaquia",
        "Eslovenia",
        "Suecia",
        "Suiza",
        "Siria",
        "Túnez",
        "Turquía",
        "Ucrania",
        "Emiratos Árabes Unidos",
        "Reino Unido",
        "Estados Unidos",
        "Uruguay",
        "Uzbekistán",
        "Venezuela",
        "Yemen"
      ]
    }
  },
  computed: {
    effectiveFieldRules() {
      return this.fieldRules && this.fieldRules.length
        ? this.fieldRules
        : this.rules.char_max_80;
    },
    canRemoveItem() {
      return Array.isArray(this.value) && this.value.length > 1;
    },
    fieldLabel() {
      return null;
    },
    fieldPlaceholder() {
      return this.placeholder || this.label;
    }
  },
  methods: {
    reviewEmail(index) {
      if (this.nameField === 'email' && this.suggestExampleEmails && !this.disabledForm && !this.readOnly) {
        this.$set(this.reviewedEmails, index, this.value[index]);
      }
    },
    emailSuggestion(index) {
      return this.nameField === 'email' && this.suggestExampleEmails &&
        this.reviewedEmails[index] === this.value[index] && looksLikePlaceholderEmail(this.value[index])
        ? placeholderEmail(this.personId, index) : '';
    },
    useEmailSuggestion(index) {
      const suggestion = this.emailSuggestion(index);
      if (!suggestion || this.disabledForm || this.readOnly) return;
      const updated = [...this.value];
      updated[index] = suggestion;
      this.$emit('input', updated);
      this.$emit('change');
    },
    arrayFieldRowClass(position) {
      return {
        "array-field-row": true,
        "array-field-row--stacked": true,
        "array-field-row--first": position === 1,
        "array-field-row--last": position === this.value.length
      };
    },
    canAddItem(maxItems) {
      return (
        Array.isArray(this.value) &&
        this.value.length < maxItems &&
        !(this.disabledForm || this.readOnly)
      );
    },
    counterFor(value, limit) {
      return value && value.length >= limit ? limit : false;
    },
    addItem() {
      this.value.push("");
      this.$emit("input", this.value);
      let name = this.nameField + (this.value.length - 1);
      this.focusItem(name);
    },
    removeItem(index) {
      this.value.splice(index, 1);
      this.$emit("input", this.value);
      const nextIndex = Math.max(0, Math.min(index, this.value.length - 1));
      if (this.value.length > 0) {
        this.focusItem(this.nameField + nextIndex);
      }
    },
    focusItem(name) {
      this.$nextTick(() => {
        if (!this.$refs[name] || !this.$refs[name][0]) {
          return;
        }
        const theElement = this.$refs[name][0].$el;
        const input = theElement.querySelector(
          "input:not([type=hidden]),textarea:not([type=hidden])"
        );
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 0);
        }
      });
    }
  }
};
</script>

<style scoped>
.email-placeholder-proposal { overflow-wrap: anywhere; margin-block: 4px; }
.email-placeholder-warning ::v-deep .v-alert__content { min-width: 0; }
.array-field-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.array-field-row--stacked:not(.array-field-row--first) {
  margin-top: -1px;
}

.array-field-control {
  flex: 1 1 auto;
  min-width: 0;
}

.array-field-delete {
  flex: 0 0 auto;
  margin-top: 8px;
}

.array-field-add {
  margin-top: -4px;
}

.array-field-row--stacked:not(.array-field-row--first) ::v-deep .v-input__slot {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.array-field-row--stacked:not(.array-field-row--last) ::v-deep .v-input__slot {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

@media (max-width: 600px) {
  .array-field-row {
    gap: 4px;
  }

  .array-field-delete {
    margin-top: 7px;
  }
}
</style>
